// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1Cvfi","header":"ReportDetails_header__2o9G4","title":"ReportDetails_title__1athv","left":"ReportDetails_left__Kt7NR"};